import {createContext, useContext, useEffect, useState} from 'react';
import {useAuth} from '@clerk/nextjs';

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const {getToken} = useAuth();
    const [token, setToken] = useState(null);

    const fetchToken = async () => {
        const newToken = await getToken();
        console.debug(newToken);
        setToken(newToken);
        localStorage.setItem('token', newToken);
    };

    useEffect(() => {
        fetchToken();
    }, []);

    return (
        <AuthContext.Provider value={{token, fetchToken}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => useContext(AuthContext);
